import { render } from "./SaveBar.vue?vue&type=template&id=24e58db0&scoped=true&ts=true"
import script from "./SaveBar.vue?vue&type=script&lang=ts"
export * from "./SaveBar.vue?vue&type=script&lang=ts"

import "./SaveBar.vue?vue&type=style&index=0&id=24e58db0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e58db0"]])

export default __exports__